exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._320SDZ6DtG_i_ybNxLv8nz{margin:10px 0}", ""]);
// Exports
exports.locals = {
	"feedbackDialogCheckbox": "_320SDZ6DtG_i_ybNxLv8nz"
};